import { Field, Float, ID, Int, InputType, ObjectType } from 'type-graphql'
import { ActionArgs } from '@ztechapps/common.contract'
import { MilkPickupDriverRef } from '../entities/MilkPickupDriverRef'
import { MilkPickupRouteRef } from '../entities/MilkPickupRouteRef'

@InputType()
export class GetOverviewDataArgs extends ActionArgs {
  @Field(() => Int, { nullable: true })
  clientUtcOffset?: number
}

@ObjectType()
@InputType('OverviewWeightDataInput')
export class OverviewWeightData {
  @Field(() => Date, { nullable: true })
  period?: Date

  @Field(() => Float, { nullable: true })
  weight?: number
}

@ObjectType()
@InputType('GetOverviewDataResultInput')
export class GetOverviewDataResult {
  @Field(() => OverviewWeightData, { nullable: true })
  currentDayWeight?: OverviewWeightData

  @Field(() => OverviewWeightData, { nullable: true })
  currentMonthWeight?: OverviewWeightData
}

@InputType()
export class DailyHauledMilkWeightsArgs extends ActionArgs {
  @Field(() => Int, { nullable: true })
  clientUtcOffset?: number

  @Field(() => Date, { nullable: true })
  startDate?: Date

  @Field(() => Date, { nullable: true })
  endDate?: Date
}

@ObjectType()
export class CurrentDriverActivityResult {
  @Field(() => ID)
  _id: string

  @Field(() => String, { nullable: true })
  ticketNo?: string

  @Field(() => Float, { nullable: true })
  totalWeight?: number

  @Field(() => String, { nullable: true })
  status?: string

  @Field(() => MilkPickupDriverRef, { nullable: true })
  driver?: MilkPickupDriverRef

  @Field(() => MilkPickupRouteRef, { nullable: true })
  route?: MilkPickupRouteRef
}
